import React, { useState } from 'react';
import UploadHistoryTableContainer from '../UploadHistoryTableContainer/UploadHistoryTableContainer';
import { PageContainer, ContentContainer } from './UploadHistoryContainer.styles';

export default function UploadHistoryContainer({ activeTab, onViewLog }) {
  const [tabIndex] = useState(0);

  // This container just passes through the onViewLog handler to the table,
  // so clicking the Eye button can open the Review modal (readOnly for complete, editable for incomplete).
  return (
    <PageContainer>
      <ContentContainer activeTab={activeTab}>
        <UploadHistoryTableContainer tabIndex={tabIndex} onViewLog={onViewLog} />
      </ContentContainer>
    </PageContainer>
  );
}
